import * as yup from 'yup';

export const documentCommentsSchema = yup.object().shape({
  documentComment: yup
    .string()
    .max(4000, 'Polje "Komentar" mora imati manje od 4000 karaktera.'),

});
